import { ProgressCard } from 'design-system/src/components/ProgressCard/ProgressCard';
import styled from 'styled-components';
import { CardContent, CardSection, CardSubSection, START_STEP_DESKTOP_MIN_HEIGHT } from './styles';
import SignupFlowContent from './SignupFlowContent';
import { ResponsiveButton } from './ResponsiveComponents';
import CertificationIcons from './CertificationIcons';
import { PageContainerWithLogo } from './PageContainerWithLogo.tsx';

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  align-items: center;
`;

const PatientButtonContainer = styled.div`
  margin-top: 4px;
  text-align: center;
`;

export type NewPracticeOrJoinProps = {
  className?: string;
  onJoinExisting: () => void;
  onCreateNew: () => void;
  onClickPatientOption: () => void;
};

export const NewPracticeOrJoin = ({
  className,
  onJoinExisting,
  onCreateNew,
  onClickPatientOption,
}: NewPracticeOrJoinProps) => {
  return (
    <PageContainerWithLogo className={className}>
      <ProgressCard progressBar={{ current: 1, total: 4 }} desktopMinHeight={`${START_STEP_DESKTOP_MIN_HEIGHT}px`}>
        <CardContent>
          <CardSection>
            <SignupFlowContent />
          </CardSection>
          <CardSubSection>
            <ButtonGroup>
              <ResponsiveButton
                desktopText="Join a practice already using Tandem"
                mobileText="Join a practice on Tandem"
                variant="secondary"
                onClick={onJoinExisting}
                width="full"
              />
              <ResponsiveButton
                desktopText="Set up a new practice"
                mobileText="Set up a new practice"
                variant="primary"
                onClick={onCreateNew}
                width="full"
              />
            </ButtonGroup>
            <PatientButtonContainer>
              <ResponsiveButton
                desktopText="I am a patient"
                mobileText="I am a patient"
                variant="link"
                onClick={onClickPatientOption}
                width="full"
              />
            </PatientButtonContainer>
          </CardSubSection>
        </CardContent>
      </ProgressCard>
      <CertificationIcons />
    </PageContainerWithLogo>
  );
};

export default NewPracticeOrJoin;
